<!-- <h2 mat-dialog-title i18n>{{ data.title }}</h2> -->
<div class="full-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title i18n>{{ data.title }}</h2>
    <button mat-icon-button class="close-button" [disabled]="isDisabled" (click)="onPrimaryAction()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div class="inpt-section" *ngIf="data.inputFileName">
      <div class="custom-title" i18n>Enter file name</div>
      <app-input [formCntlName]="nameControl" [inputType]="'text'" [placeholder]="'Enter file name'"></app-input>

      <div *ngIf="invalidIfileName === true" style="color: red">file name is required.</div>
      <div *ngIf="nameExists === true && !invalidIfileName" style="color: red">Name already exists.</div>
      <div *ngIf="nameControl.hasError('maxlength')" style="color: red">Name cannot be longer than 256 characters</div>
      <div *ngIf="nameControl.hasError('whitespace')" style="color: red">Input cannot be just spaces.</div>
    </div>
    <div class="inpt-section description-textarea" *ngIf="data.inputFileDescription">
      <label class="input-label" i18n>File Description</label>
      <textarea [formControl]="descriptionControl" placeholder="File Description" rows="3" i18n></textarea>

      <div *ngIf="descriptionControl.hasError('maxlength')" style="color: red">
        Description cannot be longer than 1024 characters
      </div>
      <div *ngIf="descriptionControl.hasError('whitespace')" style="color: red">Input cannot be just spaces.</div>
    </div>

    <p i18n>{{ data.description }}</p>

    <app-file-upload
      [apiUrl]="data.uploadConfig.apiUrl"
      [acceptedFileTypes]="data.uploadConfig.acceptedFileTypes"
      [maxFileSize]="data.uploadConfig.maxFileSize"
      [useChunking]="data.uploadConfig.useChunking"
      [chunkSize]="data.uploadConfig.chunkSize"
      [autoProcessQueue]="false"
      [maxFiles]="10"
      [addRemoveLinks]="true"
      [dictDefaultMessage]="data.uploadConfig.dictDefaultMessage"
      [onUploadStarted]="onUploadStarted"
      [onAllCompleted]="onAllUploadsComplete.bind(this)"
      (fileAdded)="onFileAdded($event)"
      (uploadSuccess)="onCompleted($event)"
      [featureName]="data.uploadConfig.featureType"
      [files]="data.files"
      [fileName]="nameControl.value"
      [fileDescription]="descriptionControl.value"
      [isFileExist]="
        nameExists === null || this.invalidIfileName || nameControl.hasError('maxlength') ? true : nameExists
      "
      [custom_fileName]="data.inputFileName"
    >
    </app-file-upload>
  </mat-dialog-content>
  <mat-dialog-actions> </mat-dialog-actions>
</div>
